// extracted by mini-css-extract-plugin
module.exports = {"table":"style__table___3-F55","column":"style__column___9n53l","icon":"style__icon___1L9SM"};